document.addEventListener("DOMContentLoaded", function () {
    const shareBtns = document.querySelectorAll(".shareBtn");
    const shareModal = document.getElementById('shareModal');
    if (!shareModal || shareBtns.length === 0) return; // No modal or buttons, nothing to do

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const shareOptions = shareModal.querySelectorAll('.share-modal-options [data-share]');

    // Fetch meta tags and canonical URL
    const pageUrl = document.querySelector('meta[property="og:url"]')?.content || document.querySelector('link[rel="canonical"]')?.href || window.location.href;
    const pageTitle = document.querySelector('meta[property="og:title"]')?.content || document.title;
    const pageDescription = document.querySelector('meta[property="og:description"]')?.content || '';
    const pageImage = document.querySelector('meta[property="og:image"]')?.content || '';
    
    // Ensure pageUrl is a string
    const finalPageUrl = typeof pageUrl === 'string' ? pageUrl : window.location.href;

    function isAndroid() {
        return /android/i.test(userAgent);
    }

    function isIOS() {
        return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    }

    function showModal() {
        shareModal.classList.add('show');
        shareModal.style.display = 'block';
        shareModal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('modal-open');
        const backdrop = document.createElement('div');
        backdrop.classList.add('modal-backdrop', 'fade', 'show');
        document.body.appendChild(backdrop);
    }

    function hideModal() {
        shareModal.classList.remove('show');
        shareModal.style.display = 'none';
        shareModal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('modal-open');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) backdrop.remove();
    }

    // Use event delegation for the close button (works if click is on <i> inside button)
    document.addEventListener('click', function(event) {
        if (event.target.id === 'customShareModalClose' || event.target.closest('#customShareModalClose')) {
            hideModal();
        }
    });

    // Show modal on share button click if sharing is not supported
    shareBtns.forEach(shareBtn => {
        shareBtn.addEventListener("click", function (event) {
            event.preventDefault();

            if (isAndroid()) {
                const intentUrl = `intent://share/#Intent;action=android.intent.action.SEND;type=text/plain;S.android.intent.extra.TEXT=${encodeURIComponent(finalPageUrl)};end`;
                window.location.href = intentUrl;
            } else if (isIOS() && navigator.share) {
                navigator.share({
                    title: pageTitle,
                    text: pageDescription,
                    url: finalPageUrl,
                }).catch((error) => {
                    // console.error("Error sharing:", error)
                });
            } else {
                showModal();
            }
        });
    });

    // Close modal on data-bs-dismiss="modal" buttons
    shareModal.querySelectorAll('[data-bs-dismiss="modal"]').forEach(button => {
        button.addEventListener('click', hideModal);
    });

    // Close modal when clicking outside (on the backdrop)
    shareModal.addEventListener('click', function (event) {
        if (event.target === shareModal) {
            hideModal();
        }
    });

    // Close modal on ESC key press
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && shareModal.classList.contains('show')) {
            hideModal();
        }
    });

    // Handle share options
    shareOptions.forEach(option => {
        option.addEventListener('click', function () {
            const shareType = this.getAttribute('data-share');
            const encodedUrl = encodeURIComponent(finalPageUrl);
            const encodedTitle = encodeURIComponent(pageTitle);
            const encodedDescription = encodeURIComponent(pageDescription);

            switch (shareType) {
                case 'copy':
                    navigator.clipboard.writeText(finalPageUrl).then(() => {
                        // alert('Link copied to clipboard!');
                    }).catch(err => {
                        // console.error('Failed to copy: ', err);
                    });
                    hideModal(); // Close modal after copying
                    break;
                case 'email':
                    window.location.href = `mailto:?subject=${encodedTitle}&body=${encodedDescription}%0A${encodedUrl}`;
                    break;
                case 'whatsapp':
                    window.open(`https://api.whatsapp.com/send?text=${encodedTitle}%0A${encodedUrl}`, '_blank');
                    break;
                case 'messenger':
                    window.open(`https://www.facebook.com/messenger/share/?link=${encodedUrl}&app_id=YOUR_APP_ID`, '_blank');
                    break;
                case 'facebook':
                    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, '_blank');
                    break;
                case 'twitter':
                    window.open(`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`, '_blank');
                    break;
                default:
                    // console.log('Share type not supported:', shareType);
            }
        });
    });
});